(function TourSearchResults($, Adzuki)
{
	"use strict";
	$(document).ready(function documentReady()
	{
		var tourSearchPages = ['/TourSearch/view'];

		Adzuki.onload(tourSearchPages, function onload()
		{
			$('.tour-image').click(function showAlternateSailingDates(e) {
				var image        = $(this).data('url'),
					$modal       = $(".modal");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading Image...');

				$modal.find('.modal-body').html('<img src="' + image + '" class="img-responsive">');

				$modal.find('.modal-title').text('Image');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		}, false);
	});
}(jQuery, window.Adzuki || {}));